<div class="relative">
  <div class="overlayerContent ">
    <div class="p-5 relative">
      <div class="bg-primary-500/70 absolute backdrop-blur-md inset-0"></div>
      <img src="/assets/images/patternHover.png"
           alt=""
           class="absolute inset-0  w-full h-full object-fill ">
      <div
        class="mt-3 intro-x grid lg:grid-cols-5 md:grid-cols-3 grid-cols-2  justify-start items-start  gap-4 w-11/12 mx-auto min-h-[340px]"
        [style]="{'--order':1, 'opacity' : 0}">
        @for (item of hudumaList; track item) {
          <div (click)="routeNext(item?.tag)"
               class="flex flex-col items-center justify-center gap-4">
            <div class="hudumaIcon text-white">
              <mat-icon [svgIcon]="item?.icon"></mat-icon>
            </div>
            <div class="text-white lg:text-lg md:text-md text-sm ">
              {{ item?.name | concat | translate }}
            </div>
          </div>
        }
      </div>
    </div>
    <div (mouseover)="exitHover.emit(null)" class="min-h-[170vh] w-full backdrop-blur-lg"></div>
  </div>
</div>
